module.exports = __webpack_public_path__ + "static/media/cfield-construction.668e4e54.png";